// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caption-dialog {
  min-width: 500px;
  max-width: 600px;
  padding: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 85vh;
  height: auto;
}
@media (max-width: 768px) {
  .caption-dialog {
    min-width: 90vw;
    max-width: 90vw;
    max-height: 90vh;
  }
}

::ng-deep .mat-dialog-container {
  padding: 0 !important;
  overflow: hidden;
  max-height: 85vh !important;
}
::ng-deep .caption-dialog-container .mat-dialog-content {
  margin: 0;
  padding: 0;
}
::ng-deep .caption-dialog-container .mat-dialog-actions {
  margin: 0;
  padding: 0;
}
::ng-deep .caption-dialog .mat-dialog-content {
  padding: 9px 10px !important;
  box-sizing: border-box;
}
::ng-deep .caption-dialog .dialog-actions .mat-button,
::ng-deep .caption-dialog .dialog-actions .mat-raised-button {
  margin: 0 !important;
  line-height: 1 !important;
}

.dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e4e8f0;
}
.dialog-header h2 {
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 20px;
  font-weight: 600;
  color: #111827;
}
.dialog-header h2 .header-icon {
  color: #5ea1d8;
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.dialog-header .close-button {
  color: #6b7280;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: transparent;
  border: 1px solid transparent;
  padding: 0;
  margin: 0;
}
.dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
  border-color: #e5e7eb;
}
.dialog-header .close-button:active {
  background: #e5e7eb;
  transform: scale(0.95);
}
.dialog-header .close-button:focus {
  outline: none;
}
.dialog-header .close-button:focus-visible {
  outline: none;
}
.dialog-header .close-button mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-content {
  padding: 20px 24px !important;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}
.dialog-content::-webkit-scrollbar {
  width: 8px;
}
.dialog-content::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
.dialog-content::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.dialog-content::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.form-container {
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.full-width {
  width: 100%;
}

::ng-deep .caption-dialog .mat-form-field {
  margin-bottom: 0;
  margin-top: 0;
  width: 100%;
}
::ng-deep .caption-dialog .mat-form-field-wrapper {
  padding-bottom: 0;
  margin-bottom: 0;
}
::ng-deep .caption-dialog .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 16px 14px !important;
  min-height: 56px;
}
::ng-deep .caption-dialog .mat-form-field-appearance-outline .mat-form-field-outline {
  top: 0;
}
::ng-deep .caption-dialog .mat-form-field-appearance-outline .mat-form-field-label {
  margin-top: 0;
}
::ng-deep .caption-dialog .mat-form-field-subscript-wrapper {
  margin-top: 4px;
}
::ng-deep .caption-dialog .dialog-content .form-container {
  margin: 0;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
}

.dialog-actions {
  padding: 20px 24px;
  border-top: 1px solid #e4e8f0;
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  align-items: center;
  margin: 0;
  min-height: 72px;
  box-sizing: border-box;
}
.dialog-actions button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  min-width: 110px;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  box-sizing: border-box;
  line-height: 1;
  white-space: nowrap;
  margin: 0;
}
.dialog-actions button mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.dialog-actions .cancel-btn {
  color: #6b7280;
  background: transparent;
  border: 1px solid #d1d5db;
}
.dialog-actions .cancel-btn:hover {
  background: #f9fafb;
  border-color: #9ca3af;
  color: #374151;
}
.dialog-actions .cancel-btn:active {
  background: #f3f4f6;
  border-color: #6b7280;
}
.dialog-actions .save-btn {
  background: #5ea1d8;
  color: white;
  border: 1px solid #5ea1d8;
}
.dialog-actions .save-btn:hover:not(:disabled) {
  background: #4a8fc4;
  border-color: #4a8fc4;
  box-shadow: 0 2px 4px rgba(94, 161, 216, 0.3);
}
.dialog-actions .save-btn:active:not(:disabled) {
  background: #3d7ba8;
  border-color: #3d7ba8;
  transform: translateY(1px);
}
.dialog-actions .save-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #9ca3af;
  border-color: #9ca3af;
}
@media (max-width: 768px) {
  .dialog-actions {
    padding: 16px;
    flex-direction: column-reverse;
    gap: 12px;
    min-height: auto;
  }
  .dialog-actions button {
    width: 100%;
    height: 44px;
    min-width: unset;
  }
}

.cover-image-section {
  margin-top: 8px;
  padding: 0;
  background: transparent;
}

.thumbnail-section-header {
  margin-bottom: 16px;
}
.thumbnail-section-header h4 {
  font-size: 14px;
  font-weight: 500;
  color: #030303;
  margin: 0 0 4px 0;
  line-height: 20px;
}
.thumbnail-section-header p {
  font-size: 13px;
  color: #606060;
  margin: 0;
  line-height: 18px;
}

.cover-image-upload-area {
  width: 100%;
  position: relative;
}

.cover-image-preview {
  position: relative;
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e4e8f0;
  background: #f9fafb;
}
.cover-image-preview img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
  max-height: 225px;
}
.cover-image-preview .remove-cover-image-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.cover-image-preview .remove-cover-image-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}
.cover-image-preview .remove-cover-image-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  line-height: 18px;
}

.cover-image-upload-placeholder {
  width: 100%;
  max-width: 400px;
  padding: 32px 24px;
  border: 2px dashed #d3d3d3;
  border-radius: 8px;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.cover-image-upload-placeholder:hover {
  border-color: #5ea1d8;
  background: #f0f7ff;
}
.cover-image-upload-placeholder:hover mat-icon {
  color: #5ea1d8;
}
.cover-image-upload-placeholder mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  color: #9ca3af;
  transition: color 0.2s ease;
}
.cover-image-upload-placeholder span {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}
.cover-image-upload-placeholder small {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}

.cover-image-upload-progress {
  width: 100%;
  max-width: 400px;
  padding: 16px;
  border: 1px solid #e4e8f0;
  border-radius: 8px;
  background: #f9fafb;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.cover-image-upload-progress mat-progress-bar {
  width: 100%;
  height: 8px;
  border-radius: 4px;
}
.cover-image-upload-progress span {
  font-size: 12px;
  color: #6b7280;
  text-align: center;
}

@media (max-width: 768px) {
  .cover-image-preview,
  .cover-image-upload-placeholder,
  .cover-image-upload-progress {
    max-width: 100%;
  }
  .cover-image-upload-placeholder {
    padding: 24px 16px;
  }
}
.support-documents-section ::ng-deep .mat-mdc-form-field {
  margin-bottom: 0;
}
.support-documents-section ::ng-deep button[mat-raised-button] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0;
}
.support-documents-section ::ng-deep button[mat-raised-button] mat-icon {
  flex-shrink: 0;
  margin-right: 4px;
}
.support-documents-section ::ng-deep button[mat-raised-button] span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tagged-items-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  margin-bottom: 12px;
}
.tagged-items-section .section-subtitle {
  font-size: 14px;
  font-weight: 500;
  color: #111827;
  margin: 0;
}
.tagged-items-section .form-hint {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
}
.tagged-items-section ::ng-deep .mat-mdc-chip-set {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.tagged-items-section ::ng-deep .mat-mdc-chip {
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #e3f2fd !important;
  color: #1d67a3 !important;
  position: relative;
  padding-right: 8px !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip:hover {
  background-color: #bbdefb !important;
  transform: scale(1.05);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
  color: #1d67a3 !important;
  padding: 0 !important;
  margin-left: 4px !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button:hover {
  opacity: 1;
  background-color: rgba(29, 103, 163, 0.1) !important;
}
.tagged-items-section ::ng-deep .mat-mdc-chip .edit-chip-button mat-icon {
  color: #1d67a3 !important;
}

.tagged-items-chips ::ng-deep .mat-mdc-chip {
  position: relative;
  padding-right: 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/caption-dialog/caption-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AACF;AACE;EAVF;IAWI,eAAA;IACA,eAAA;IACA,gBAAA;EAEF;AACF;;AAGE;EACE,qBAAA;EACA,gBAAA;EACA,2BAAA;AAAJ;AAII;EACE,SAAA;EACA,UAAA;AAFN;AAKI;EACE,SAAA;EACA,UAAA;AAHN;AASI;EACK,4BAAA;EACH,sBAAA;AAPN;AAcM;;EAEE,oBAAA;EACA,yBAAA;AAZR;;AAkBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,gCAAA;AAfF;AAiBE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAfJ;AAiBI;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAfN;AAmBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,uBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AAjBJ;AAmBI;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAjBN;AAoBI;EACE,mBAAA;EACA,sBAAA;AAlBN;AAqBI;EACE,aAAA;AAnBN;AAsBI;EACE,aAAA;AApBN;AAuBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AArBN;;AA0BA;EACE,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;AAvBF;AA0BE;EACE,UAAA;AAxBJ;AA2BE;EACE,mBAAA;EACA,kBAAA;AAzBJ;AA4BE;EACE,mBAAA;EACA,kBAAA;AA1BJ;AA4BI;EACE,mBAAA;AA1BN;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AA5BF;;AA+BA;EACE,WAAA;AA5BF;;AAkCI;EACE,gBAAA;EACA,aAAA;EACA,WAAA;AA/BN;AAkCI;EACE,iBAAA;EACA,gBAAA;AAhCN;AAoCM;EACE,6BAAA;EACA,gBAAA;AAlCR;AAqCM;EACE,MAAA;AAnCR;AAsCM;EACE,aAAA;AApCR;AAwCI;EACE,eAAA;AAtCN;AA2CM;EACE,SAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;AAzCR;;AA+CA;EACE,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AA5CF;AA8CE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,SAAA;AA5CJ;AA8CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AA5CN;AAgDE;EACE,cAAA;EACA,uBAAA;EACA,yBAAA;AA9CJ;AAgDI;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;AA9CN;AAiDI;EACE,mBAAA;EACA,qBAAA;AA/CN;AAmDE;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AAjDJ;AAmDI;EACE,mBAAA;EACA,qBAAA;EACA,6CAAA;AAjDN;AAoDI;EACE,mBAAA;EACA,qBAAA;EACA,0BAAA;AAlDN;AAqDI;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;AAnDN;AAuDE;EAlFF;IAmFI,aAAA;IACA,8BAAA;IACA,SAAA;IACA,gBAAA;EApDF;EAsDE;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EApDJ;AACF;;AAyDA;EACE,eAAA;EACA,UAAA;EACA,uBAAA;AAtDF;;AAyDA;EACE,mBAAA;AAtDF;AAwDE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAtDJ;AAyDE;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AAvDJ;;AA2DA;EACE,WAAA;EACA,kBAAA;AAxDF;;AA2DA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAxDF;AA0DE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AAxDJ;AA2DE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AAzDJ;AA2DI;EACE,8BAAA;EACA,qBAAA;AAzDN;AA4DI;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA1DN;;AA+DA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;EACA,yBAAA;AA5DF;AA8DE;EACE,qBAAA;EACA,mBAAA;AA5DJ;AA8DI;EACE,cAAA;AA5DN;AAgEE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,2BAAA;AA9DJ;AAiEE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA/DJ;AAkEE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAhEJ;;AAoEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAjEF;AAmEE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;AAjEJ;AAoEE;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAlEJ;;AAsEA;EACE;;;IAGE,eAAA;EAnEF;EAsEA;IACE,kBAAA;EApEF;AACF;AA0EI;EACE,gBAAA;AAxEN;AA2EI;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;AAzEN;AA2EM;EACE,cAAA;EACA,iBAAA;AAzER;AA4EM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AA1ER;;AAiFA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;AA9EF;AAgFE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA9EJ;AAiFE;EACE,eAAA;EACA,cAAA;EACA,SAAA;AA/EJ;AAmFI;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAjFN;AAoFI;EACE,eAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;AAlFN;AAoFM;EACE,oCAAA;EACA,sBAAA;EACA,wCAAA;AAlFR;AAqFM;EACE,YAAA;EACA,6BAAA;EACA,yBAAA;EACA,qBAAA;EACA,2BAAA;AAnFR;AAqFQ;EACE,UAAA;EACA,oDAAA;AAnFV;AAsFQ;EACE,yBAAA;AApFV;;AA6FI;EACE,kBAAA;EACA,6BAAA;AA1FN","sourcesContent":[".caption-dialog {\n  min-width: 500px;\n  max-width: 600px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  max-height: 85vh;\n  height: auto;\n\n  @media (max-width: 768px) {\n    min-width: 90vw;\n    max-width: 90vw;\n    max-height: 90vh;\n  }\n}\n\n// Override Material Dialog defaults\n::ng-deep {\n  .mat-dialog-container {\n    padding: 0 !important;\n    overflow: hidden;\n    max-height: 85vh !important;\n  }\n\n  .caption-dialog-container {\n    .mat-dialog-content {\n      margin: 0;\n      padding: 0;\n    }\n\n    .mat-dialog-actions {\n      margin: 0;\n      padding: 0;\n    }\n  }\n\n  // Ensure dialog-content padding is respected\n  .caption-dialog {\n    .mat-dialog-content {\n         padding: 9px 10px !important;\n      box-sizing: border-box;\n    }\n  }\n\n  // Override Material button styles for proper alignment\n  .caption-dialog {\n    .dialog-actions {\n      .mat-button,\n      .mat-raised-button {\n        margin: 0 !important;\n        line-height: 1 !important;\n      }\n    }\n  }\n}\n\n.dialog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e4e8f0;\n\n  h2 {\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    font-size: 20px;\n    font-weight: 600;\n    color: #111827;\n\n    .header-icon {\n      color: #5ea1d8;\n      font-size: 24px;\n      width: 24px;\n      height: 24px;\n    }\n  }\n\n  .close-button {\n    color: #6b7280;\n    width: 40px;\n    height: 40px;\n    min-width: 40px;\n    min-height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s ease;\n    background: transparent;\n    border: 1px solid transparent;\n    padding: 0;\n    margin: 0;\n\n    &:hover {\n      background: #f3f4f6;\n      color: #374151;\n      border-color: #e5e7eb;\n    }\n\n    &:active {\n      background: #e5e7eb;\n      transform: scale(0.95);\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &:focus-visible {\n      outline: none;\n    }\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n      line-height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n.dialog-content {\n  padding: 20px 24px !important;\n  max-height: 50vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n  box-sizing: border-box;\n  \n  // Custom scrollbar styling\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  \n  &::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n  }\n  \n  &::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n    \n    &:hover {\n      background: #a8a8a8;\n    }\n  }\n}\n\n.form-container {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n  padding: 10px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.full-width {\n  width: 100%;\n}\n\n// Ensure proper spacing and padding for Material form fields\n::ng-deep {\n  .caption-dialog {\n    .mat-form-field {\n      margin-bottom: 0;\n      margin-top: 0;\n      width: 100%;\n    }\n\n    .mat-form-field-wrapper {\n      padding-bottom: 0;\n      margin-bottom: 0;\n    }\n\n    .mat-form-field-appearance-outline {\n      .mat-form-field-infix {\n        padding: 16px 14px !important;\n        min-height: 56px;\n      }\n\n      .mat-form-field-outline {\n        top: 0;\n      }\n\n      .mat-form-field-label {\n        margin-top: 0;\n      }\n    }\n\n    .mat-form-field-subscript-wrapper {\n      margin-top: 4px;\n    }\n\n    // Ensure form-container respects parent padding\n    .dialog-content {\n      .form-container {\n        margin: 0;\n        padding: 0;\n        width: 100%;\n        box-sizing: border-box;\n      }\n    }\n  }\n}\n\n.dialog-actions {\n  padding: 20px 24px;\n  border-top: 1px solid #e4e8f0;\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n  align-items: center;\n  margin: 0;\n  min-height: 72px;\n  box-sizing: border-box;\n\n  button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 10px 24px;\n    font-size: 14px;\n    font-weight: 500;\n    height: 40px;\n    min-width: 110px;\n    border-radius: 6px;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    box-sizing: border-box;\n    line-height: 1;\n    white-space: nowrap;\n    margin: 0;\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      line-height: 18px;\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .cancel-btn {\n    color: #6b7280;\n    background: transparent;\n    border: 1px solid #d1d5db;\n\n    &:hover {\n      background: #f9fafb;\n      border-color: #9ca3af;\n      color: #374151;\n    }\n\n    &:active {\n      background: #f3f4f6;\n      border-color: #6b7280;\n    }\n  }\n\n  .save-btn {\n    background: #5ea1d8;\n    color: white;\n    border: 1px solid #5ea1d8;\n\n    &:hover:not(:disabled) {\n      background: #4a8fc4;\n      border-color: #4a8fc4;\n      box-shadow: 0 2px 4px rgba(94, 161, 216, 0.3);\n    }\n\n    &:active:not(:disabled) {\n      background: #3d7ba8;\n      border-color: #3d7ba8;\n      transform: translateY(1px);\n    }\n\n    &:disabled {\n      opacity: 0.6;\n      cursor: not-allowed;\n      background: #9ca3af;\n      border-color: #9ca3af;\n    }\n  }\n\n  @media (max-width: 768px) {\n    padding: 16px;\n    flex-direction: column-reverse;\n    gap: 12px;\n    min-height: auto;\n\n    button {\n      width: 100%;\n      height: 44px;\n      min-width: unset;\n    }\n  }\n}\n\n// Cover Image Upload Section\n.cover-image-section {\n  margin-top: 8px;\n  padding: 0;\n  background: transparent;\n}\n\n.thumbnail-section-header {\n  margin-bottom: 16px;\n\n  h4 {\n    font-size: 14px;\n    font-weight: 500;\n    color: #030303;\n    margin: 0 0 4px 0;\n    line-height: 20px;\n  }\n\n  p {\n    font-size: 13px;\n    color: #606060;\n    margin: 0;\n    line-height: 18px;\n  }\n}\n\n.cover-image-upload-area {\n  width: 100%;\n  position: relative;\n}\n\n.cover-image-preview {\n  position: relative;\n  width: 100%;\n  max-width: 400px;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid #e4e8f0;\n  background: #f9fafb;\n\n  img {\n    width: 100%;\n    height: auto;\n    display: block;\n    object-fit: cover;\n    max-height: 225px; // 16:9 aspect ratio for 400px width\n  }\n\n  .remove-cover-image-btn {\n    position: absolute;\n    top: 8px;\n    right: 8px;\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    padding: 0;\n    border-radius: 50%;\n    background: rgba(0, 0, 0, 0.6);\n    color: white;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background: rgba(0, 0, 0, 0.8);\n      transform: scale(1.1);\n    }\n\n    mat-icon {\n      font-size: 18px;\n      width: 18px;\n      height: 18px;\n      line-height: 18px;\n    }\n  }\n}\n\n.cover-image-upload-placeholder {\n  width: 100%;\n  max-width: 400px;\n  padding: 32px 24px;\n  border: 2px dashed #d3d3d3;\n  border-radius: 8px;\n  background: #fafafa;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  &:hover {\n    border-color: #5ea1d8;\n    background: #f0f7ff;\n\n    mat-icon {\n      color: #5ea1d8;\n    }\n  }\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    color: #9ca3af;\n    transition: color 0.2s ease;\n  }\n\n  span {\n    font-size: 14px;\n    font-weight: 500;\n    color: #374151;\n  }\n\n  small {\n    font-size: 12px;\n    color: #6b7280;\n    text-align: center;\n  }\n}\n\n.cover-image-upload-progress {\n  width: 100%;\n  max-width: 400px;\n  padding: 16px;\n  border: 1px solid #e4e8f0;\n  border-radius: 8px;\n  background: #f9fafb;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  mat-progress-bar {\n    width: 100%;\n    height: 8px;\n    border-radius: 4px;\n  }\n\n  span {\n    font-size: 12px;\n    color: #6b7280;\n    text-align: center;\n  }\n}\n\n@media (max-width: 768px) {\n  .cover-image-preview,\n  .cover-image-upload-placeholder,\n  .cover-image-upload-progress {\n    max-width: 100%;\n  }\n\n  .cover-image-upload-placeholder {\n    padding: 24px 16px;\n  }\n}\n\n// Support Documents Section Styles\n.support-documents-section {\n  ::ng-deep {\n    .mat-mdc-form-field {\n      margin-bottom: 0;\n    }\n    \n    button[mat-raised-button] {\n      display: inline-flex;\n      align-items: center;\n      justify-content: center;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      margin-top: 0;\n      \n      mat-icon {\n        flex-shrink: 0;\n        margin-right: 4px;\n      }\n      \n      span {\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n}\n\n// Tagged Items Section Styles\n.tagged-items-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n  margin-bottom: 12px;\n\n  .section-subtitle {\n    font-size: 14px;\n    font-weight: 500;\n    color: #111827;\n    margin: 0;\n  }\n\n  .form-hint {\n    font-size: 12px;\n    color: #6b7280;\n    margin: 0;\n  }\n\n  ::ng-deep {\n    .mat-mdc-chip-set {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n    }\n\n    .mat-mdc-chip {\n      cursor: pointer;\n      transition: all 0.2s ease;\n      background-color: #e3f2fd !important;\n      color: #1d67a3 !important;\n      position: relative;\n      padding-right: 8px !important;\n\n      &:hover {\n        background-color: #bbdefb !important;\n        transform: scale(1.05);\n        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n      }\n\n      .edit-chip-button {\n        opacity: 0.7;\n        transition: opacity 0.2s ease;\n        color: #1d67a3 !important;\n        padding: 0 !important;\n        margin-left: 4px !important;\n\n        &:hover {\n          opacity: 1;\n          background-color: rgba(29, 103, 163, 0.1) !important;\n        }\n\n        mat-icon {\n          color: #1d67a3 !important;\n        }\n      }\n    }\n  }\n}\n\n.tagged-items-chips {\n  ::ng-deep {\n    .mat-mdc-chip {\n      position: relative;\n      padding-right: 8px !important;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
